import script from "./ChooseUserSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseUserSingle.vue?vue&type=script&setup=true&lang=js"

import "./ChooseUserSingle.vue?vue&type=style&index=0&id=7f6b743b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f6b743b"]])

export default __exports__